var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxIconColor = function SvgBoxIconColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0c.084 0 .167.005.249.015a3.291 3.291 0 0 0-.343.25l-.083.072-.096.09-.148.152L16.34 2H2v16h16V9.888l2-2.271V18a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h16Z",
    fill: "#525252",
    fillRule: "nonzero"
  })));
};
export default SvgBoxIconColor;